module.exports = __webpack_public_path__ + "img/Icon_awesome-check-circle.4a8933e4.svg";